import axios, { AxiosInstance } from 'axios';
import { Config } from '../config';

class ApiClient {
  instance: AxiosInstance;
  constructor() {
    this.instance = axios.create({
      baseURL: Config.baseURL,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json, text/plain, */*',
      },
    });
  }
}

export default new ApiClient();
